var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4151 4.86288C11.1652 4.1128 12.1825 3.69141 13.2433 3.69141H18.0003C19.657 3.69141 21 5.03443 21 6.69114V11.4481C21 12.5089 20.5786 13.5262 19.8285 14.2763L13.292 20.8128C12.1205 21.9843 10.2212 21.9843 9.04972 20.8128L3.8786 15.6417C2.70713 14.4702 2.70713 12.5709 3.8786 11.3994L10.4151 4.86288ZM13.2433 5.69123C12.7129 5.69123 12.2043 5.90193 11.8292 6.27697L5.29269 12.8135C4.9022 13.204 4.9022 13.8371 5.29269 14.2276L10.4638 19.3987C10.8543 19.7892 11.4874 19.7892 11.8779 19.3987L18.4144 12.8622C18.7895 12.4871 19.0002 11.9785 19.0002 11.4481V6.69114C19.0002 6.13891 18.5525 5.69123 18.0003 5.69123H13.2433Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.128L6.43662 9.69141L16 19.2548L14.5634 20.6914L5 11.128Z",
    fill: "#6B92FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.69141C17 9.24369 16.5523 9.69141 16 9.69141C15.4477 9.69141 15 9.24369 15 8.69141C15 8.13912 15.4477 7.69141 16 7.69141C16.5523 7.69141 17 8.13912 17 8.69141Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagEmpty);
export default __webpack_public_path__ + "static/media/tag-empty.c3b9ed8d.svg";
export { ForwardRef as ReactComponent };